module.exports = __webpack_public_path__ + "media/images/signal-strength-60-aa0805da276c3b777f591b5c64e23408.svg";